export default "__VITE_ASSET__CLx9S2L9__"